import React from "react";

/**
 * Subtle animated tech network background — wave/grid of cyan particles
 * connected by thin lines. Pure SVG, performant, no canvas.
 */
const WaveBackground = ({ className = "", opacity = 0.5 }) => {
  // Pre-computed grid of nodes (deterministic, no randomness needed)
  const cols = 22;
  const rows = 10;
  const nodes = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const x = (c / (cols - 1)) * 100;
      // wave offset for vertical position
      const wave = Math.sin((c / cols) * Math.PI * 2 + r * 0.6) * 1.4;
      const y = (r / (rows - 1)) * 100 + wave;
      nodes.push({ x, y, r, c });
    }
  }

  return (
    <svg
      className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      aria-hidden
      style={{ opacity }}
    >
      <defs>
        <radialGradient id="wave-fade" cx="50%" cy="50%" r="65%">
          <stop offset="0%" stopColor="#1dc7e9" stopOpacity="0.35" />
          <stop offset="55%" stopColor="#1dc7e9" stopOpacity="0.08" />
          <stop offset="100%" stopColor="#1dc7e9" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="wave-line" x1="0" x2="1">
          <stop offset="0%" stopColor="#1dc7e9" stopOpacity="0" />
          <stop offset="50%" stopColor="#1dc7e9" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#1dc7e9" stopOpacity="0" />
        </linearGradient>
      </defs>

      <rect width="100" height="100" fill="url(#wave-fade)" />

      {/* horizontal connections */}
      {nodes.map((n, i) => {
        if (n.c === cols - 1) return null;
        const next = nodes[i + 1];
        return (
          <line
            key={`h-${i}`}
            x1={n.x}
            y1={n.y}
            x2={next.x}
            y2={next.y}
            stroke="url(#wave-line)"
            strokeWidth="0.06"
          />
        );
      })}

      {/* vertical connections */}
      {nodes.map((n, i) => {
        if (n.r === rows - 1) return null;
        const next = nodes[i + cols];
        return (
          <line
            key={`v-${i}`}
            x1={n.x}
            y1={n.y}
            x2={next.x}
            y2={next.y}
            stroke="#1dc7e9"
            strokeOpacity="0.08"
            strokeWidth="0.05"
          />
        );
      })}

      {/* node dots */}
      {nodes.map((n, i) => (
        <circle
          key={`n-${i}`}
          cx={n.x}
          cy={n.y}
          r="0.18"
          fill="#1dc7e9"
          opacity={0.55}
        >
          <animate
            attributeName="opacity"
            values="0.25;0.85;0.25"
            dur={`${3 + (i % 5)}s`}
            begin={`${(i % 9) * 0.2}s`}
            repeatCount="indefinite"
          />
        </circle>
      ))}
    </svg>
  );
};

export default WaveBackground;
